import React, {useEffect, useState} from 'react';
import {Beacon} from "types/Beacon";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    beacon: Beacon | null
    show: boolean
    onDelete?: (beacon: Beacon) => any
    onDeleteFail?: (beacon: Beacon, error: unknown) => any
    onCancel?: () => any
}

function DeleteBeacon(props: Props) {
    const {beacon, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(beacon?.name || 'this beacon');
    const {mutateAsync: deleteBeacon} = useMutation(ngage.beacons.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(beacon) setName(beacon.name)
    }, [beacon]);

    async function handleDeleteBeacon() {
        if (beacon) {
            try {
                await deleteBeacon(beacon.id)
                await invalidate('beacons.all')

                notify("success", "Beacon Deleted", `${beacon.name} has been permanently removed`)
                if (onDelete) onDelete(beacon)
            } catch (error) {
                notify("error", "Beacon Not Deleted", `${beacon.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(beacon, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Beacon "
            body={`Are you sure you want to permanently delete beacon '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteBeacon}
            onCancel={handleCancel}
        />
    );
}

export default DeleteBeacon;